/* eslint-disable */
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Add } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getTarjetasDebito } from "../../../project/services/MedioCobroService";
import { getTarjetasCredito } from "../../../project/services/MedioCobroService";
import { getObraSocialPlanes } from "../../../project/services/ObraSocialPlanService";
import { getCacheData } from "../../services/CacheService";
import { getCaja } from "../../../project/services/CajaService";
import BuscarClienteDialog from "../gestion-atencion/BuscarClienteDialog";
import CajaAjusteDialog from "./CajaAjusteDialog";
import CajaComprobanteDialog from "./CajaComprobanteDialog";
import Message from "../../../project/utils/Message";
import { v4 as uuidv4 } from "uuid";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
  codigoCaja: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  estadoActual: "todo",
  codigoGA: "",
  tipoCobro: "",
  tarjetaDebito: "",
  numeroCuponTarjetaDebito: "",
  numeroLoteTarjetaDebito: "",
  tarjetaCredito: "",
  numeroCuponTarjetaCredito: "",
  numeroLoteTarjetaCredito: "",
  billetera: "",
  obraSocial: "",
  descripcionObraSocial: "",
  obraSocialPlan: "",
  descripcionObraSocialPlan: "",
  numeroBeneficiario: "",
  numeroAutorizacion: "",
  descripcionDescuentoEspecial: "",
  descripcionOtraFormadeCobro: "",
  cuentaBancaria: "",
  banco: "",
  numeroCheque: "",
  idTipoAjuste: "",
  descripcionAjuste: "",
  idTipoComprobante: "",
  descripcionComprobante: "",
  numeroComprobante: "",
  idProveedor: "",
  nombre: "",
  apellido: "",
  idCliente: "",
};

const mediosDeCobroOptions = [
  {
    id: "efectivo",
    label: "Efectivo",
  },
  {
    id: "tarjeta-debito",
    label: "Tarjeta de Débito",
  },
  {
    id: "tarjeta-credito",
    label: "Tarjeta de Crédito",
  },
  {
    id: "billetera-virtual",
    label: "Billetera Virtual",
  },
  {
    id: "obra-social",
    label: "Obra Social",
  },
  {
    id: "descuento-especial",
    label: "Descuento especial",
  },
  {
    id: "otro",
    label: "Otra forma de pago",
  },
  {
    id: "transferencia-bancaria",
    label: "Transferencia Bancaria",
  },
  {
    id: "cheque",
    label: "Cheque",
  },
];

const nameItemsText = "Caja";
//
// #############################################################################
//
const Caja = () => {
  const params = useParams();
  const navigate = useNavigate();
  const idCaja = params.idCaja;
  const action = params.action;
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [tarjetasDebito, setTarjetasDebito] = useState([]);
  const [tarjetasCredito, setTarjetasCredito] = useState([]);
  const [cuentasBancarias, setCuentasBancarias] = useState([]);
  const [billeteras, setBilleteras] = useState([]);
  const [obrasSociales, setObrasSociales] = useState([]);
  const [obraSocialPlanes, setObraSocialPlanes] = useState([]);
  const [tiposAjuste, setTiposAjuste] = useState([]);
  const [tiposComprobante, setTiposComprobante] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [movimientosCaja, setMovimientosCaja] = useState([]);
  const [cajaSelected, setCajaSelected] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [valueACMedioDeCobro, setValueACMedioDeCobro] = useState({
    id: "",
    label: ""
  });
  const [inputValueACMedioDeCobro, setInputValueACMedioDeCobro] = useState("");
  const [openDialogCliente, setopenDialogCliente] = useState(false);
  const [openDialogAjuste, setOpenDialogAjuste] = useState(false)
  const [openDialogComprobante, setOpenDialogComprobante] = useState(false)
  const [tipoMovimiento, setTipoMovimiento] = useState("todos");
  const [disabledtipoMovimiento, setDisabledtipoMovimiento] = useState(false);
  const [valueACObraSocial, setValueACObraSocial] = useState({
    id: "",
    descripcion: ""
  });
  const [inputValueACObraSocial, setInputValueACObraSocial] = useState("");
  const [valueACObraSocialPlan, setValueACObraSocialPlan] = useState({
    id: "",
    descripcion_obra_social_plan: "",
    id_obra_social: ""
  })
  const [inputValueACObraSocialPlan, setInputValueACObraSocialPlan] = useState("");
  const [obraSocialPlanesTmp, setObraSocialPlanesTmp] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [codigoCaja, setCodigoCaja] = useState('')
  const [estadoCaja, setEstadoCaja] = useState('')

  const tableColumns = [
    {
      field: "tipo_movimiento",
      headerName: "Tipo",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tipo_movimiento;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "importe_total_cobrado",
      headerName: "Total cobrado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = ""
        if (params.row.tipo_movimiento === "cobranza") {
          _val = params.row.importe_cobrado.toFixed(2);
        }
        else if (params.row.tipo_movimiento === "ajuste" || params.row.tipo_movimiento === "gasto") {
          _val = params.row.importe_caja_movimiento.toFixed(2);
        }
        return _val;
      },
    },
    {
      field: "descripcion",
      headerName: "Descripción del movimiento",
      headerAlign: "center",
      align: "left",
      flex: 5,
      sortable: false,
      renderCell: (params) => {
        let _val = ""
        if (params.row.tipo_movimiento === "cobranza") {
          switch (params.row.tipo_cobro) {
            case "efectivo":
              _val = "EFECTIVO";
              break;
            case "tarjeta-debito":
              _val =
                "TARJETA DEBITO - " +
                params.row.marca_tarjeta +
                " " +
                params.row.banco_entidad_banco_tarjeta +
                " - CUPON: " +
                params.row.numero_cupon +
                " - LOTE: " +
                params.row.numero_lote +
                " - DESCUENTO: " +
                params.row.porcentaje_descuento +
                "%";
              break;

            case "tarjeta-credito":
              _val =
                "TARJETA CREDITO - " +
                params.row.marca_tarjeta +
                " " +
                params.row.banco_entidad_banco_tarjeta +
                " - CUOTAS: " +
                params.row.cantidad_cuotas +
                " - CUPON: " +
                params.row.numero_cupon +
                " - LOTE: " +
                params.row.numero_lote +
                " - DESCUENTO: " +
                params.row.porcentaje_descuento +
                "%" +
                " - INTERES: " +
                params.row.porcentaje_interes +
                "%";
              break;

            case "billetera-virtual":
              _val =
                "BILLETERA VIRTUAL - " +
                params.row.descripcion_billetera;
              break;

            case "obra-social":
              _val =
                "OBRA SOCIAL - " +
                params.row.descripcion_obra_social +
                " - " +
                params.row.descripcion_obra_social_plan +
                " - BENEFICIARIO: " +
                params.row.apellido_cliente +
                " " +
                params.row.nombre_cliente +
                " - NUMERO: " +
                params.row.numero_beneficiario +
                " - AUTORIZACION: " +
                params.row.numero_autorizacion;
              break;

            case "descuento-especial":
              _val = "DESCUENTO ESPECIAL "
              break;

            case "otro":
              _val = "OTRA FORMA DE PAGO "
              break;

            case "transferencia-bancaria":
              _val =
                "TRANSFERENCIA BANCARIA - " +
                params.row.banco_cuenta_bancaria +
                " - COMPROBANTE: " +
                params.row.numero_comprobante;
              break;

            case "cheque":
              _val =
                "CHEQUE " +
                params.row.banco +
                " - NUMERO: " +
                params.row.numero +
                " - VENCIMIENTO: " +
                params.row.fecha_cobro;
              break;
          }
        } else if (params.row.tipo_movimiento === "ajuste") {
          let sumaResta = params.row.suma_resta === "suma" ? "+" : "-";
          _val = ("( " + sumaResta + " ) " + params.row.descripcion_tipo_ajuste + ' - ' + params.row.descripcion_caja_movimiento)
        } else if (params.row.tipo_movimiento === "gasto") {
          _val = (params.row.descripcion_tipo_comprobante + ' - ' + params.row.descripcion_caja_movimiento)
        }
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_actualizacion_caja_movimiento",
      headerName: "Fecha/Hora",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_actualizacion_caja_movimiento;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "anulado_caja_movimiento",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = ""
        if (params.row.anulado_caja_movimiento === true) {
          _val = 'ANULADO'
        }
        return _val;
      },
    },
    {
      field: "usuario_creacion",
      headerName: "Vendedor?",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario_creacion;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.tipo_movimiento === "cobranza" && (
            <Tooltip title="ver cobranza">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleCobranzaById(params.row)}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.tipo_movimiento === "ajuste" && (
            <Tooltip title="ver ajuste">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionCrudAjuste(params.row, "view")}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.tipo_movimiento === "ajuste" && action === "update" && !params.row.anulado_caja_movimiento && (
            <Tooltip title="editar movimiento">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionCrudAjuste(params.row, "update")}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.tipo_movimiento === "ajuste" && action === "update" && !params.row.anulado_caja_movimiento && (
            <Tooltip title="anular movimiento">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionCrudAjuste(params.row, "delete")}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.tipo_movimiento === "gasto" && (
            <Tooltip title="ver comprobante">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionCrudComprobante(params.row, "view")}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.tipo_movimiento === "gasto" && action === "update" && !params.row.anulado_caja_movimiento && (
            <Tooltip title="editar movimiento">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionCrudComprobante(params.row, "update")}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {/* anular gasto */}

          {params.row.tipo_movimiento === "gasto" && action === "update" && !params.row.anulado_caja_movimiento && (
            <Tooltip title="anular movimiento">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionCrudComprobante(params.row, "delete")}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
        </>),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "No se encontraron registros",
      noResultsOverlayLabel: "No se encontraron registros",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    load()
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadTarjetasDebito();
    loadTarjetasCredito();
    loadCuentasBancarias();
    loadBilleteras();
    loadObrasSociales();
    loadObraSocialPlanes();
    loadTiposAjuste();
    loadTiposComprobante();
    loadProveedores();

    setValueACObraSocial({
      id: searchData.obraSocial,
      descripcion: searchData.descripcionObraSocial,
    });
    setValueACObraSocialPlan({
      id: searchData.obraSocialPlan,
      descripcion_obra_social_plan: searchData.descripcionObraSocialPlan,
      id_obra_social: searchData.obraSocial,
    });

    let _codigoCaja = sessionStorage.getItem('codigoCaja');
    let _estadoCaja = sessionStorage.getItem('estadoCaja');
    if (_codigoCaja) {
      setCodigoCaja(_codigoCaja)
    }
    if (_estadoCaja) {
      setEstadoCaja((_estadoCaja).toUpperCase())
    }
  }, []);
  //
  // ################################################################################
  // controlo autocomplete de obra social
  useEffect(() => {
    if (valueACObraSocial.id !==
      valueACObraSocialPlan.id_obra_social) {
      setValueACObraSocialPlan({
        id: "",
        descripcion_obra_social_plan: "",
        id_obra_social: "",
      });
      setObraSocialPlanesTmp([]);
      if (valueACObraSocial) {
        setObraSocialPlanesTmp
          (obraSocialPlanes.filter((item) => {
            return item.id_obra_social === valueACObraSocial.id
              ? item
              : null;
          }));
      }
    }
  }, [valueACObraSocial])
  //
  // ################################################################################
  //
  const loadTarjetasDebito = async () => {
    const response = await getTarjetasDebito();
    if (response.ok) {
      let _tarjetasDebito = [];
      let _tarjeta = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion =
          item.marca_tarjeta.toUpperCase() +
          " - " +
          item.banco_entidad.toUpperCase() +
          (item.porcentaje_descuento > 0
            ? " - " + item.porcentaje_descuento + " % descuento"
            : "");

        _tarjeta = {
          idTarjeta: item.id_tarjeta,
          idTarjetaBanco: item.id_tarjeta_banco,
          idTarjetaBancoAcuerdo: item.id_tarjeta_banco_acuerdo,
          id: item.id_tarjeta_banco_acuerdo,
          porcentajeDescuento: item.porcentaje_descuento,
          tarjeta: _descripcion,
          label: _descripcion,
        };
        _tarjetasDebito.push(_tarjeta);
      });
      setTarjetasDebito(_tarjetasDebito);
    } else {
      setTarjetasDebito([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTarjetasCredito = async () => {
    const response = await getTarjetasCredito();
    if (response.ok) {
      let _tarjetasCredito = [];
      let _tarjeta = {};
      let _descripcion = "";

      response.data.data.forEach((item) => {
        _descripcion =
          item.marca_tarjeta.toUpperCase() +
          " - " +
          item.banco_entidad.toUpperCase() +
          " - " +
          item.cantidad_cuotas +
          (item.cantidad_cuotas === 1 ? " cuota" : " cuotas") +
          (item.porcentaje_descuento > 0
            ? " - " + item.porcentaje_descuento + " % descuento"
            : "") +
          (item.porcentaje_interes > 0 ? " - " + item.porcentaje_interes + " % interés" : "");
        _tarjeta = {
          idTarjeta: item.id_tarjeta,
          idTarjetaBanco: item.id_tarjeta_banco,
          idTarjetaBancoAcuerdo: item.id_tarjeta_banco_acuerdo,
          id: item.id_tarjeta_banco_acuerdo,
          porcentajeDescuento: item.porcentaje_descuento,
          porcentajeInteres: item.porcentaje_interes,
          cantidadCuotas: item.cantidad_cuotas,
          tarjeta: _descripcion,
          label: _descripcion,
        };
        _tarjetasCredito.push(_tarjeta);
      });
      setTarjetasCredito(_tarjetasCredito);
    } else {
      setTarjetasCredito([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadCuentasBancarias = async () => {
    const response = await getCacheData("cuenta_bancaria");
    if (response.ok) {
      let _cuentasBancarias = [];
      let _cuentaBancaria = {};
      let _descripcion = "";
      response.data.data.forEach((item) => {
        _descripcion = item.banco.toUpperCase() + " - CBU: " + item.numero_cbu.toUpperCase();
        _cuentaBancaria = {
          id: item.id,
          idCuentaBancaria: item.id,
          bancoCuentaBancaria: _descripcion,
          label: _descripcion,
        };
        _cuentasBancarias.push(_cuentaBancaria);
      });
      setCuentasBancarias(_cuentasBancarias);
    } else {
      setCuentasBancarias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBilleteras = async () => {
    const response = await getCacheData("billetera");
    if (response.ok) {
      setBilleteras(response.data.data);
    } else {
      setBilleteras([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadObrasSociales = async () => {
    const response = await getCacheData("obra_social");
    if (response.ok) {
      setObrasSociales(response.data.data);
    } else {
      setObrasSociales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadObraSocialPlanes = async () => {
    const response = await getObraSocialPlanes();
    if (response.ok) {
      setObraSocialPlanes(response.data.data);
    } else {
      setObraSocialPlanes([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTiposAjuste = async () => {
    const response = await getCacheData("tipo_ajuste");
    if (response.ok) {
      setTiposAjuste(response.data.data);
    } else {
      setTiposAjuste([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTiposComprobante = async () => {
    const response = await getCacheData("tipo_comprobante");
    if (response.ok) {
      setTiposComprobante(response.data.data);
    } else {
      setTiposComprobante([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor")
    if (response.ok) {
      setProveedores(response.data.data);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const seleccionarCaja = (currentRowsSelected, allRowsSelected, rowsSelected) => {
    setCajaSelected(rowsSelected);
  }
  //
  // ################################################################################ 
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setValueACMedioDeCobro({ id: "", label: "" });
    setInputValueACMedioDeCobro("");
    setTotalRowsCount(0);
    setMovimientosCaja([]);
    setCajaSelected([])
    setTipoMovimiento("todos");
  };
  //
  // ################################################################################
  //
  const handleBorrarMovimiento = () => {
    setSearchData(initialSearchData);
    setValueACMedioDeCobro({ id: "", label: "" });
    setInputValueACMedioDeCobro("");
    setTotalRowsCount(0);
    setMovimientosCaja([]);
    setCajaSelected([]);
  };
  //
  // ################################################################################
  //
  const handleBuscar = async () => {
    load();
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      idCaja: idCaja,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    }
    _params.tipoMovimiento = tipoMovimiento;

    if (searchData.idTipoAjuste) {
      _params.idTipoAjuste = searchData.idTipoAjuste;
    }
    if (searchData.descripcionAjuste) {
      _params.descripcionAjuste = searchData.descripcionAjuste;
    }
    if (searchData.idTipoComprobante) {
      _params.idTipoComprobante = searchData.idTipoComprobante;
    }
    if (searchData.descripcionComprobante) {
      _params.descripcionComprobante = searchData.descripcionComprobante;
    }
    if (searchData.idProveedor) {
      _params.idProveedor = searchData.idProveedor;
    }
    if (searchData.numeroComprobante) {
      _params.numeroComprobante = searchData.numeroComprobante;
    }

    switch (inputValueACMedioDeCobro) {
      case "Efectivo":
        _params.tipoCobro = "efectivo";
        break;
      case "Tarjeta de Débito":
        _params.tipoCobro = "tarjeta-debito";
        break;
      case "Tarjeta de Crédito":
        _params.tipoCobro = "tarjeta-credito";
        break;
      case "Billetera Virtual":
        _params.tipoCobro = "billetera-virtual";
        break;
      case "Obra Social":
        _params.tipoCobro = "obra-social";
        break;
      case "Descuento especial":
        _params.tipoCobro = "descuento-especial";
        break;
      case "Otra forma de pago":
        _params.tipoCobro = "otro";
        break;
      case "Transferencia Bancaria":
        _params.tipoCobro = "transferencia-bancaria";
        break;
      case "Cheque":
        _params.tipoCobro = "cheque";
        break;
    }

    if (searchData.tarjetaDebito) {
      _params.tarjetaDebito = searchData.tarjetaDebito;
    }
    if (searchData.numeroCuponTarjetaDebito) {
      _params.numeroCuponTarjetaDebito = searchData.numeroCuponTarjetaDebito;
    }
    if (searchData.numeroLoteTarjetaDebito) {
      _params.numeroLoteTarjetaDebito = searchData.numeroLoteTarjetaDebito;
    }
    if (searchData.tarjetaCredito) {
      _params.tarjetaCredito = searchData.tarjetaCredito;
    }
    if (searchData.numeroCuponTarjetaCredito) {
      _params.numeroCuponTarjetaCredito = searchData.numeroCuponTarjetaCredito;
    }
    if (searchData.numeroLoteTarjetaCredito) {
      _params.numeroLoteTarjetaCredito = searchData.numeroLoteTarjetaCredito;
    }
    if (searchData.billetera) {
      _params.billetera = searchData.billetera;
    }
    if (searchData.obraSocial) {
      _params.obraSocial = searchData.obraSocial;
    }
    if (searchData.obraSocialPlan) {
      _params.obraSocialPlan = searchData.obraSocialPlan;
    }
    if (searchData.numeroBeneficiario) {
      _params.numeroBeneficiario = searchData.numeroBeneficiario;
    }
    if (searchData.numeroAutorizacion) {
      _params.numeroAutorizacion = searchData.numeroAutorizacion;
    }
    if (searchData.descripcionDescuentoEspecial) {
      _params.descripcionDescuentoEspecial = searchData.descripcionDescuentoEspecial;
    }
    if (searchData.descripcionOtraFormadeCobro) {
      _params.descripcionOtraFormadeCobro = searchData.descripcionOtraFormadeCobro;
    }
    if (searchData.cuentaBancaria) {
      _params.cuentaBancaria = searchData.cuentaBancaria;
    }
    if (searchData.banco) {
      _params.banco = searchData.banco;
    }
    if (searchData.numeroCheque) {
      _params.numeroCheque = searchData.numeroCheque;
    }
    if (searchData.idCliente) {
      _params.idCliente = searchData.idCliente;
    }

    if (valueACObraSocial.id) {
      _params.obraSocial = valueACObraSocial.id;
    }
    if (valueACObraSocialPlan.id) {
      _params.obraSocialPlan = valueACObraSocialPlan.id;
    }

    setIsDoingSomething(true);
    const response = await getCaja(_params)
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);

      let _movimientosCaja = response.data.data.map((item) => {
        return {
          ...item,
          id: uuidv4(),
        }
      })
      setMovimientosCaja(_movimientosCaja);
    }
    else {
      setMessage({
        severity: response.messageSeverity,
        messageText: response.messageText,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaCliente = () => {
    setopenDialogCliente(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaCliente = () => {
    setopenDialogCliente(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaCliente = (cliente) => {
    setopenDialogCliente(false);
    setSearchData({
      ...searchData,
      nombre: cliente.nombre,
      apellido: cliente.apellido,
      idCliente: cliente.id,
    });
  }
  //
  // ################################################################################
  //
  const handleChangetipoMovimiento = (event, newValue) => {
    setTipoMovimiento(newValue);
    setDisabledtipoMovimiento(false);
    handleBorrarMovimiento();
  }
  //
  // ################################################################################
  //
  const handleDialogCajaAjusteSave = () => {
    load();
    setOpenDialogAjuste(false);
  };
  //
  // ################################################################################
  //
  const handleDialogCajaComprobanteSave = () => {
    load();
    setOpenDialogComprobante(false);
  };
  //
  // ################################################################################
  //
  const handleDialogCajaAjusteClose = () => {
    load();
    setOpenDialogAjuste(false);
  };
  //
  // ################################################################################
  //
  const handleDialogCajaComprobanteClose = () => {
    load();
    setOpenDialogComprobante(false);
  };
  //
  // ################################################################################
  //
  const handleClickActionCrudAjuste = (parRow, parAction) => {

    let _itemCrud = {};

    if (parAction === "new") {
      _itemCrud = {};
    } else {
      _itemCrud = {
        id: parRow.id_caja_movimiento,
        idCaja: idCaja,
        idTipoAjuste: parRow.id_tipo_ajuste,
        descripcion: parRow.descripcion_caja_movimiento,
        importe: parRow.importe_caja_movimiento,
        motivoAnulacion: parRow.motivo_anulacion_caja_movimiento_anulado ? parRow.motivo_anulacion_caja_movimiento_anulado : ""
      }
    }
    setItemCrud(_itemCrud);
    setActionCrud(parAction);
    setOpenDialogAjuste(true);
  }
  //
  // ################################################################################
  //
  const handleClickActionCrudComprobante = (parRow, parAction) => {

    let _itemCrud = {};

    if (parAction === "new") {
      _itemCrud = {};
    } else {
      _itemCrud = {
        id: parRow.id_caja_movimiento,
        idCaja: idCaja,
        idTipoComprobante: parRow.id_tipo_comprobante,
        descripcion: parRow.descripcion_caja_movimiento,
        idProveedor: parRow.id_proveedor,
        numeroComprobante: parRow.numero_comprobante,
        importe: parRow.importe_caja_movimiento,
        motivoAnulacion: parRow.motivo_anulacion_caja_movimiento_anulado ? parRow.motivo_anulacion_caja_movimiento_anulado : ''
      }
    }
    setItemCrud(_itemCrud);
    setActionCrud(parAction);
    setOpenDialogComprobante(true);
  }
  //
  // ################################################################################
  //
  const handleCobranzaById = (parRow) => {
    navigate("/cobranza/" + parRow.id_cobranza + "/view");
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                  <Typography variant="h5" display="block" gutterBottom>
                    {nameItemsText} {codigoCaja}
                  </Typography>

                  <Box display="flex" alignItems="center">
                    <Typography variant="h6" display="block" gutterBottom sx={{ mr: 4 }}>
                      Estado de la caja
                    </Typography>
                    <Typography variant="h6" display="block" gutterBottom sx={{ mr: 4, color: '#1976d2' }}>
                      {estadoCaja}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* ToggleButtonGroup para cambio de tipo de busqueda */}
              <Grid item xs={12} sm={6} md={4} lg={12}>
                <Typography variant="h6" display="-ms-flexbox" gutterBottom style={{ fontWeight: 300, color: '#555' }}>
                  Tipo de Movimiento
                </Typography>
                <Box sx={{ mt: 1, mr: 2, mb: 3 }}>
                  <ToggleButtonGroup
                    color="primary"
                    size="small"
                    value={tipoMovimiento}
                    exclusive={true}
                    onChange={handleChangetipoMovimiento}
                    disabled={false}
                  >
                    <ToggleButton
                      value="todos"
                      sx={{ mr: 1, onblur: "#1976d2", color: "#1976d2", borderColor: "#1976d2", width: 'auto', minWidth: '150px' }}
                      size="small"
                      disabled={disabledtipoMovimiento}
                    >
                      Todos
                    </ToggleButton>

                    <ToggleButton
                      value="cobranza"
                      sx={{ mr: 1, onblur: "#1976d2", color: "#1976d2", borderColor: "#1976d2", width: 'auto', minWidth: '150px' }}
                      size="small"
                      disabled={disabledtipoMovimiento}
                    >
                      cobranza
                    </ToggleButton>

                    <ToggleButton
                      value="ajuste"
                      sx={{ mr: 1, onblur: "#1976d2", color: "#1976d2", borderColor: "#1976d2", width: 'auto', minWidth: '150px' }}
                      size="small"
                      disabled={disabledtipoMovimiento}
                    >
                      ajuste
                    </ToggleButton>

                    <ToggleButton
                      value="gasto"
                      sx={{ mr: 1, onblur: "#1976d2", color: "#1976d2", borderColor: "#1976d2", width: 'auto', minWidth: '150px' }}
                      size="small"
                      disabled={disabledtipoMovimiento}
                    >
                      gasto
                    </ToggleButton>

                  </ToggleButtonGroup>
                </Box>

                {tipoMovimiento === "cobranza" && (
                  <>
                    <Box sx={{ mt: 1, mr: 2, mb: 3 }}>

                      <Grid item xs={12} md={12} lg={12}></Grid>
                      <Grid container spacing={1} >
                        <Grid item xs={12} md={2} lg={2}>
                          <TextField
                            sx={{ width: "100%" }}
                            inputProps={{
                              autoComplete: "off",
                            }}
                            id="nombre"
                            label="Nombre de Cliente"
                            variant="outlined"
                            size="small"
                            name="nombre"
                            disabled={true}
                            value={searchData.nombre}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={2} lg={2}>
                          <TextField
                            sx={{ width: "100%" }}
                            inputProps={{
                              autoComplete: "off",
                            }}
                            id="apellido"
                            label="Apellido de Cliente"
                            variant="outlined"
                            size="small"
                            name="apellido"
                            disabled={true}
                            value={searchData.apellido}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={2} lg={2}>
                          <Button
                            sx={{ width: "100%", mb: 1 }}
                            variant="contained"
                            onClick={handleClickOpenBusquedaCliente}
                            startIcon={<SavedSearchIcon />}
                          >
                            Cliente
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={6} lg={4}>
                        <Autocomplete
                          id="mediosDeCobro"
                          size="small"
                          width="50%"
                          sx={{ mb: 1, mt: 1 }}
                          value={valueACMedioDeCobro}
                          onChange={(event, newValue) => {
                            setValueACMedioDeCobro(newValue);
                            setSearchData({
                              ...searchData,
                              tipoCobro: newValue === null ? "" : newValue.id,
                            });
                          }}
                          inputValue={inputValueACMedioDeCobro}
                          onInputChange={(event, newInputValue) => {
                            setInputValueACMedioDeCobro(newInputValue);
                          }}
                          options={mediosDeCobroOptions}
                          renderInput={(params) => (
                            <TextField {...params} label="Medio de Cobro" />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.value === value.value
                          }
                        />
                      </Grid>

                      {valueACMedioDeCobro.id === "tarjeta-debito" && (
                        <>
                          <Grid item xs={12} md={4} lg={4}>
                            <FormControl sx={{ width: "100%" }}>
                              <InputLabel id="tarjeta-debito-select-label">
                                Tarjeta de Débito
                              </InputLabel>
                              <Select
                                labelId="tarjeta-debito-select-label"
                                id="tarjeta-debito-select"
                                name="tarjetaDebito"
                                value={searchData.tarjetaDebito}
                                label="Tarjeta de Débito"
                                size="small"
                                sx={{ mb: 1 }}
                                onChange={handleChange}
                                MenuProps={{ style: { maxHeight: "300px" } }}
                              >
                                {tarjetasDebito.map((item) => (
                                  <MenuItem
                                    key={item.idTarjetaBancoAcuerdo}
                                    value={item.idTarjetaBancoAcuerdo}
                                  >
                                    {item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroCuponTarjetaDebito"
                              label="Número de Cupón"
                              variant="outlined"
                              size="small"
                              name="numeroCuponTarjetaDebito"
                              value={searchData.numeroCuponTarjetaDebito}
                              onChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroLoteTarjetaDebito"
                              label="Número de Lote"
                              variant="outlined"
                              size="small"
                              name="numeroLoteTarjetaDebito"
                              value={searchData.numeroLoteTarjetaDebito}
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}

                      {valueACMedioDeCobro.id === "tarjeta-credito" && (
                        <>
                          <Grid item xs={12} md={4} lg={4}>
                            <FormControl sx={{ width: "100%", mb: 1 }}>
                              <InputLabel id="tarjeta-credito-select-label">
                                Tarjeta de Crédito
                              </InputLabel>
                              <Select
                                labelId="tarjeta-credito-select-label"
                                id="tarjeta-credito-select"
                                name="tarjetaCredito"
                                value={searchData.tarjetaCredito}
                                label="Tarjeta de Crédito"
                                size="small"
                                onChange={handleChange}
                                MenuProps={{ style: { maxHeight: "300px" } }}
                              >
                                {tarjetasCredito.map((item) => (
                                  <MenuItem
                                    key={item.idTarjetaBancoAcuerdo}
                                    value={item.idTarjetaBancoAcuerdo}
                                  >
                                    {item.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroCuponTarjetaCredito"
                              label="Número de Cupón"
                              variant="outlined"
                              size="small"
                              name="numeroCuponTarjetaCredito"
                              value={searchData.numeroCuponTarjetaCredito}
                              onChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroLoteTarjetaCredito"
                              label="Número de Lote"
                              variant="outlined"
                              size="small"
                              name="numeroLoteTarjetaCredito"
                              value={searchData.numeroLoteTarjetaCredito}
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}

                      {valueACMedioDeCobro.id === "billetera-virtual" && (
                        <>
                          <Grid item xs={12} md={4} lg={4}>
                            <FormControl sx={{ width: "100%" }}>
                              <InputLabel id="billetera-select-label">
                                Billetera Virtual
                              </InputLabel>
                              <Select
                                labelId="billetera-select-label"
                                id="billetera-select"
                                name="billetera"
                                value={searchData.billetera}
                                label="Billetera"
                                size="small"
                                onChange={handleChange}
                                MenuProps={{ style: { maxHeight: "300px" } }}
                              >
                                {billeteras.map((item) => (
                                  <MenuItem key={item.id} value={item.id}
                                  >
                                    {item.descripcion}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </>
                      )}

                      {valueACMedioDeCobro.id === "obra-social" && (
                        <>
                          <Grid item xs={12} md={4} lg={4}>
                            <FormControl sx={{ width: "100%", mb: 1 }}>
                              <Autocomplete
                                size="small"
                                value={valueACObraSocial}
                                onChange={(event, newValue) => {
                                  setValueACObraSocial(newValue);
                                }}
                                inputValue={inputValueACObraSocial}
                                onInputChange={(event, newInputValue) => {
                                  setInputValueACObraSocial(newInputValue);
                                }}
                                options={obrasSociales}
                                renderInput={(params) => (
                                  <TextField {...params} label="Obras Sociales" />
                                )}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                getOptionLabel={(option) => option.descripcion ?? option}
                                disableClearable={true}
                              />
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={4} lg={4}>
                            <FormControl sx={{ width: "100%", mb: 1 }}>
                              <Autocomplete
                                size="small"
                                value={valueACObraSocialPlan}
                                onChange={(event, newValue) => {
                                  setValueACObraSocialPlan(newValue);
                                }}
                                inputValue={inputValueACObraSocialPlan}
                                onInputChange={(event, newInputValue) => {
                                  setInputValueACObraSocialPlan(newInputValue);
                                }}
                                options={obraSocialPlanesTmp}
                                renderInput={(params) => (
                                  <TextField {...params} label="Planes de Obra Social" />
                                )}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                getOptionLabel={(option) =>
                                  option.descripcion_obra_social_plan ?? option
                                }
                                disableClearable={true}
                              />
                            </FormControl>
                          </Grid>

                          <Grid container spacing={0}>
                            <Grid item xs={12} md={12} lg={12}></Grid>
                          </Grid>

                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroBeneficiario"
                              label="Número de Beneficiario"
                              variant="outlined"
                              size="small"
                              name="numeroBeneficiario"
                              value={searchData.numeroBeneficiario}
                              onChange={handleChange}
                            />
                          </Grid>

                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroAutorizacion"
                              label="Número de Autorización"
                              variant="outlined"
                              size="small"
                              name="numeroAutorizacion"
                              value={searchData.numeroAutorizacion}
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}

                      {valueACMedioDeCobro.id === "descuento-especial" && (
                        <>
                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="descripcionDescuentoEspecial"
                              label="Descripción"
                              variant="outlined"
                              size="small"
                              name="descripcionDescuentoEspecial"
                              value={searchData.descripcionDescuentoEspecial}
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}

                      {valueACMedioDeCobro.id === "otro" && (
                        <>
                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="descripcionOtraFormadeCobro"
                              label="Descripción"
                              variant="outlined"
                              size="small"
                              name="descripcionOtraFormadeCobro"
                              value={searchData.descripcionOtraFormadeCobro}
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}

                      {valueACMedioDeCobro.id ===
                        "transferencia-bancaria" && (
                          <>
                            <Grid item xs={12} md={4} lg={4}>
                              <FormControl sx={{ width: "100%", mb: 1 }}>
                                <InputLabel id="cuenta-bancaria-select-label">
                                  Cuenta Bancaria
                                </InputLabel>
                                <Select
                                  labelId="cuenta-bancaria-select-label"
                                  id="cuenta-bancaria-select"
                                  name="cuentaBancaria"
                                  value={searchData.cuentaBancaria}
                                  label="Cuenta Bancaria"
                                  size="small"
                                  onChange={handleChange}
                                  MenuProps={{ style: { maxHeight: "300px" } }}
                                >
                                  {cuentasBancarias.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4} lg={4}>
                              <TextField
                                sx={{ width: "100%" }}
                                inputProps={{
                                  autoComplete: "off",
                                }}
                                id="numeroComprobante"
                                label="Número de Comprobante"
                                variant="outlined"
                                size="small"
                                name="numeroComprobante"
                                value={searchData.numeroComprobante}
                                onChange={handleChange}
                              />
                            </Grid>
                          </>
                        )}

                      {valueACMedioDeCobro.id === "cheque" && (
                        <>
                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%", mb: 1 }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="banco"
                              label="Banco"
                              variant="outlined"
                              size="small"
                              name="banco"
                              value={searchData.banco}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={4}>
                            <TextField
                              sx={{ width: "100%" }}
                              inputProps={{
                                autoComplete: "off",
                              }}
                              id="numeroCheque"
                              label="Número de Cheque"
                              variant="outlined"
                              size="small"
                              name="numeroCheque"
                              value={searchData.numeroCheque}
                              onChange={handleChange}
                            />
                          </Grid>
                        </>
                      )}
                    </Box>
                  </>
                )}

                {/* tipoMovimiento gasto */}
                {tipoMovimiento === "gasto" && (
                  <>
                    <Box sx={{ mt: 1, mr: 2, mb: 3 }}>
                      <Grid item xs={12} md={12} lg={12}></Grid>
                      <Grid item xs={12} md={4} lg={4}>
                        <FormControl sx={{ width: "100%", mb: 1 }}>
                          <InputLabel id="cuenta-bancaria-select-label">
                            Tipo de Comprobante
                          </InputLabel>
                          <Select
                            labelId="cuenta-bancaria-select-label"
                            id="tipo-comprobante-select"
                            name="idTipoComprobante"
                            value={searchData.idTipoComprobante}
                            label="Tipo de Comprobante"
                            size="small"
                            onChange={handleChange}
                            MenuProps={{ style: { maxHeight: "300px" } }}
                          >
                            {tiposComprobante.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.descripcion}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={4} lg={4}>
                        <TextField
                          sx={{ width: "100%", mb: 1 }}
                          inputProps={{
                            autoComplete: "off",
                          }}
                          id="descripcionComprobante"
                          label="Descripción"
                          variant="outlined"
                          size="small"
                          name="descripcionComprobante"
                          value={searchData.descripcionComprobante}
                          onChange={handleChange}
                        />
                      </Grid>

                      {/* destinado a proveedores */}

                      <Grid item xs={12} md={4} lg={4}>
                        <FormControl sx={{ width: "100%", mb: 1 }}>
                          <InputLabel id="proveedor-select-label">
                            Proveedor
                          </InputLabel>
                          <Select
                            labelId="cuenta-bancaria-select-label"
                            id="idProveedor"
                            name="idProveedor"
                            value={searchData.idProveedor}
                            label="Proveedor"
                            size="small"
                            onChange={handleChange}
                            MenuProps={{ style: { maxHeight: "300px" } }}
                          >
                            {proveedores.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.descripcion}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={4} lg={4}>
                        <TextField
                          sx={{ width: "100%", mb: 1 }}
                          inputProps={{
                            autoComplete: "off",
                          }}
                          id="numeroComprobante"
                          label="N° de Comprobante"
                          variant="outlined"
                          size="small"
                          name="numeroComprobante"
                          value={searchData.numeroComprobante}
                          onChange={handleChange}
                        />
                      </Grid>

                    </Box>
                  </>
                )}
                {/* ahora para tipoMovimiento ajuste */}
                {tipoMovimiento === "ajuste" && (
                  <>
                    <Box sx={{ mt: 1, mr: 2, mb: 3 }}>
                      <Grid item xs={12} md={12} lg={12}></Grid>
                      <Grid item xs={12} md={4} lg={4}>
                        <FormControl sx={{ width: "100%", mb: 1 }}>
                          <InputLabel id="cuenta-bancaria-select-label">
                            Tipo de Ajuste
                          </InputLabel>
                          <Select
                            labelId="cuenta-bancaria-select-label"
                            id="tipo-ajuste-select"
                            name="idTipoAjuste"
                            value={searchData.idTipoAjuste}
                            label="Tipo de Ajuste"
                            size="small"
                            onChange={handleChange}
                            MenuProps={{ style: { maxHeight: "300px" } }}
                          >
                            {tiposAjuste.map((item) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.descripcion}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={4} lg={4}>
                        <TextField
                          sx={{ width: "100%" }}
                          inputProps={{
                            autoComplete: "off",
                          }}
                          id="descripcionAjuste"
                          label="Descripción"
                          variant="outlined"
                          size="small"
                          name="descripcionAjuste"
                          value={searchData.descripcionAjuste}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Box>
                  </>
                )}
              </Grid>
            </Grid>

            <Grid container spacing={1}>

              {action !== 'view' && (
                <>
                  <Grid item xs={12} md={12} lg={1.5}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Tooltip title="crear nuevo ajuste de caja">
                        <Button
                          fullWidth
                          className="btn-add"
                          variant="contained"
                          size="small"
                          onClick={() => handleClickActionCrudAjuste({}, "new")}
                          startIcon={<Add />}
                        >
                          Ajuste
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>


                  <Grid item xs={12} md={12} lg={1.5}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Tooltip title="crear nuevo ajuste de caja">
                        <Button
                          fullWidth
                          className="btn-add"
                          variant="contained"
                          size="small"
                          onClick={() => handleClickActionCrudComprobante({}, "new")}
                          startIcon={<Add />}
                        >
                          Comprobante
                        </Button>
                      </Tooltip>
                    </Box>
                  </Grid>
                </>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros de búsqueda">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={movimientosCaja}
          columns={tableColumns}
          {...tableOptions}
        />

      </Paper>

      {/* dialogo de busqueda de cliente */}
      {openDialogCliente && (
        <BuscarClienteDialog
          open={openDialogCliente}
          onClose={handleCloseBusquedaCliente}
          onSelect={handleSelectBusquedaCliente}
        />
      )}

      {/* dialogo agregar ajuste */}
      {openDialogAjuste && (
        <CajaAjusteDialog
          onSave={handleDialogCajaAjusteSave}
          onClose={handleDialogCajaAjusteClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
          tiposAjuste={tiposAjuste}
          idCaja={idCaja}
        />
      )}

      {/* dialogo agregar comprobante de gastos */}
      {openDialogComprobante && (
        <CajaComprobanteDialog
          onSave={handleDialogCajaComprobanteSave}
          onClose={handleDialogCajaComprobanteClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
          tiposComprobante={tiposComprobante}
          proveedores={proveedores}
          idCaja={idCaja}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default Caja;
